<template>
  <div class="storageDaPing">
    <!-- 头部 -->
    <div class="title" style="position: relative;">
      <img src="../../assets/cangchuDaping/blue.png" alt class="img1" />
      <div class="h2" v-if="kehuList.length>0">
        {{kehuList[this.dqIndex].tenantName}}
      </div>
      <img src="../../assets/cangchuDaping/blue.png" alt class="img2" />
      <span class="tiaozhuan">
        {{ nowDate + ' ' + nowWeek }}
      </span>
    </div>
    <!-- 主体 -->
    <div class="conent">
      <!-- 顶部 -->
      <div class="conent_top flexBox">
        <div class="top_left top">
          <!-- 绘制图表--库存量 -->
          <div class="topCon">
            <div class="leftTop"></div>
            <div class="leftBottom"></div>
            <div class="rightTop"></div>
            <div class="rightBottom"></div>
            <div class="topCon_title" >
              <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1"  style="height:auto"/>
              实时库存总量
              <img
                src="../../assets/cangchuDaping/some_blue.png"
                alt style="height:auto"
                class="img2"
              />
            </div>
            <div class="topCon_body">
              <div id="myChart" :style="{width: '23vw',height:'40vh'}"></div>
            </div>
          </div>
          <div style="width:1%;height:100%;"></div>
          <!-- 日出入库量 -->
          <div class="topCon">
            <div class="leftTop"></div>
            <div class="leftBottom"></div>
            <div class="rightTop"></div>
            <div class="rightBottom"></div>
            <div class="topCon_title">
              <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1" />
              当日出入库量
              <img
                src="../../assets/cangchuDaping/some_blue.png"
                alt
                class="img2"
              />
            </div>
            <div class="topCon_body">
              <div id="chuRuChart" :style="{width: '24vw',height:'40vh'}"></div>
            </div>
          </div>
        </div>
        <div style="width:1%;height:100%;"></div>
        <!-- 日库存量波动 -->
        <div class="top_right top topCon">
          <div class="leftTop"></div>
          <div class="leftBottom"></div>
          <div class="rightTop"></div>
          <div class="rightBottom"></div>
          <div class="topCon_title" >
            <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1" />
            历史库存量波动
            <img
              src="../../assets/cangchuDaping/some_blue.png"
              alt
              class="img2"
            />
          </div>
          <div class="topCon_body">
            <div id="kuCunChart1" :style="{width: '48vw',height:'43vh'}"></div>
          </div>
        </div>
      </div>
      <!-- 中部 -->
      <div class="conent_center flexBox">
        <div class="center_left center topCon">
          <div class="leftTop"></div>
          <div class="leftBottom"></div>
          <div class="rightTop"></div>
          <div class="rightBottom"></div>
          <div class="topCon_title" >
            <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1" />
            实时出入库作业
            <img
              src="../../assets/cangchuDaping/some_blue.png"
              alt
              class="img2"
            />
          </div>
          <div class="topCon_body table-wrapper">
            <!-- <el-table :data="workDataList">
              <el-table-column label="钢卷号" prop="list"></el-table-column>
              <el-table-column label="规格" prop="name"></el-table-column>
              <el-table-column label="材质" prop="type"></el-table-column>
              <el-table-column label="重量" prop="creator"></el-table-column>
              <el-table-column label="时间（2020）" prop="data"></el-table-column>
              <el-table-column label="操作人" prop="data"></el-table-column>
              <el-table-column label="状态" prop="data"></el-table-column>
            </el-table>-->
            <div id="table">
              <div class="tables">
                <span class="span_one">客户名称</span>
                <span class="span_one">货物名称</span>
                <span class="span_one">重量(吨)</span>
                <span class="span_one">作业时间</span>
                <span class="span_one">作业类型</span>
              </div>
              <vue-seamless-scroll
                :data="workDataList"
                :class-option="optionSetting"
                class="seamless-warp2"
              >
                <ul class="item">
                  <li
                    v-for="(item,index) in workDataList"
                    :key="index"
                    :style="item.timeDifference>120?'color:red':item.timeDifference>60?'color:yellow':''"
                  >
                    <span v-text="item.customerName"></span>
                    <span v-text="item.productTypeName"></span>
                    <span v-text="item.stockWeight"></span>
                    <span >{{ item.operationTime|dateFormat }}</span>
                    <span >{{item.operationType==1?'入库':'出库' }}</span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
        <div style="width:1%;height:100%;"></div>

        <div class="center_right center topCon">
          <div class="leftTop"></div>
          <div class="leftBottom"></div>
          <div class="rightTop"></div>
          <div class="rightBottom"></div>
          <div class="topCon_title" >
            <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1" />
            历史出入库波动
            <img
              src="../../assets/cangchuDaping/some_blue.png"
              alt
              class="img2"
            />
          </div>
          <div class="topCon_body">
            <div id="rChart" :style="{width: '48vw',height:'43vh'}"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 点击饼图-放大 -->
    <div>
      <el-dialog
        title="库存量"
        :visible.sync="echartsmark"
        width="90%"
        center
         :modal-append-to-body='false'
        :close-on-click-modal='false'
        @open="openEchartsClick()"
        :before-close="handleClose"
      >
        <div class="topCon_bodyDialog">
          <div id="myChart2" :style="{width: '80vw',height:'80vh'}"></div>
        </div>
      </el-dialog>
    </div>
    <!-- 点击日出入库-放大 -->
    <div>
      <el-dialog
        title="日出入库量"
        :visible.sync="chuRuclickmark"
        width="90%"
        center
         :modal-append-to-body='false'
        :close-on-click-modal='false'
        @open="openEchartsClick2()"
        :before-close="handleClose"
      >
        <div class="topCon_bodyDialog">
          <div id="chuRuChart2" :style="{width: '80vw',height:'70vh'}"></div>
        </div>
      </el-dialog>
    </div>
    <!-- 点击库存量-放大 -->
    <div>
      <el-dialog
        title="日库存量波动"
        :visible.sync="chuRuclickmark3"
        width="90%"
        center
         :modal-append-to-body='false'
        :close-on-click-modal='false'
        @open="openEchartsClick3()"
        :before-close="handleClose"
      >
        <div class="topCon_bodyDialog">
          <div id="kuCunChart12" :style="{width: '90vw',height:'70vh'}"></div>
        </div>
      </el-dialog>
    </div>
    <!-- 点击日出库波动-放大 -->
    <div>
      <el-dialog
        title="日出入库波动"
        :visible.sync="chuRuclickmark4"
        width="90%"
        center
         :modal-append-to-body='false'
        :close-on-click-modal='false'
        @open="openEchartsClick4()"
        :before-close="handleClose"
      >
        <div class="topCon_bodyDialog">
          <div id="rChart2" :style="{width: '90vw',height:'70vh'}"></div>
        </div>
      </el-dialog>
    </div>
    <!-- 点击出入库作业-放大 -->
    <div class="chuRuWorkBox">
      <el-dialog
        title="出入库作业"
        :visible.sync="workMark"
        width="90%"
        center
        :modal-append-to-body='false'
        :close-on-click-modal='false'
        :before-close="handleClose"
      >
        <div id="table">
          <div class="tables">
            <span class="span_one">客户名称</span>
            <span class="span_one">货物名称</span>
            <span class="span_one">重量</span>
            <span class="span_one">作业时间({{now}})</span>
            <span class="span_one">作业类型</span>
          </div>
          <vue-seamless-scroll
            :data="workDataList"
            :class-option="optionSetting"
            class="seamless-warp1"
          >
            <ul class="item">
              <li
                v-for="(item,index) in workDataList"
                :key="index"
                :style="item.timeDifference>120?'color:red':item.timeDifference>60?'color:yellow':''"
              >
               <span v-text="item.customerName"></span>
                <span v-text="item.productTypeName"></span>
                <span v-text="item.stockWeight"></span>
                <span >{{ item.operationTime|dateFormat }}</span>
                <span >{{item.operationType==1?'入库':'出库' }}</span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  findInventoryQuantity, // 1饼图
  findOperationQuantity, // ;2柱状图
  findInventoryQuantityFluctuation, //  4日库存量波动
  findOperationQuantityList, // 3出入库作业
  findInOutQuantityFluctuation, // 5日出入库量波动
  findTenantNameList // 字典-客户
} from '@/api/data-center-server'
import DonMessage from '@/utils/message'
import 'echarts-liquidfill/src/liquidFill.js' // 在这里引入

export default {
  data () {
    return {
      nowDate: '', // 当前日期
      nowWeek: '', // 当前星期
      now: new Date().getFullYear(),
      sum: 0,
      kehuMing: null,
      kehuName: '',
      allWeight: [],
      kehuAddName: '',
      kehuAddNum: '',
      bingTuList: null, // 饼图数据
      storageData: [], // 1- 饼图数据-echarts data数据
      rDataList: '0.000', // 2- 圆柱数据-入库
      chuDataList: '0.000', // 2-圆柱数据、-出库
      workDataList: [], // 3-出入库作业
      getDayInOutDataList: null, // 4-日出库波动
      getTWhStatistictDataList: null, // 5-日库存量波动

      echartsmark: false,
      workMark: false,
      chuRuclickmark: false,
      chuRuclickmark3: false,
      chuRuclickmark4: false,
      // 日出入库量数据
      instockDateList: [],
      instockWeightList: [],
      outstockDateList: [],
      outstockWeightList: [],
      instockDateListSlice: [],
      instockWeightListSlice: [],
      outstockDateListSlice: [],
      outstockWeightListSlice: [],
      // 库存量
      stockDateList: [], // 5-日期
      weightSumList: [], // 5-1库存
      stockDateListSlice: [],
      weightSumListSlice: [],
      kehuList: [
        { tenantName: this.$route.query.name ? this.$route.query.name : localStorage.getItem('tenantName') }
      ],
      // tenantName: localStorage.getItem('tenantName'),
      dqIndex: 0,
      timer: null
    }
  },

  computed: {
    optionSetting () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  mounted () {
    this.getDate()
    this.$nextTick(() => {
      this.findInventoryQuantityS() // 1-饼图tenantName
      this.findOperationQuantityS() // 2-圆柱
      this.findOperationQuantityListS() // 3-出入库作业
      this.findInOutQuantityFluctuationS() // 5-日出入库波动
      this.findInventoryQuantityFluctuationS() // 4-日库存量波动统计
    })
    let that = this
    this.timer = setInterval(function () {
      that.dqIndex = 0
      if (that.kehuList.length > 0) {
        that.findInventoryQuantityS() // 1-饼图tenantName
        that.findOperationQuantityS() // 2-圆柱
        that.findOperationQuantityListS() // 3-出入库作业
        that.findInOutQuantityFluctuationS() // 5-日出入库波动
        that.findInventoryQuantityFluctuationS() // 4-日库存量波动统计
      }
    }, 60000 * 1)//
  },
  methods: {
    // 获取当前时间
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '/' + mm + '/' + dd
    },
    // 2.1 查询仓储租户下全部或指定客户的库存量--饼图
    findInventoryQuantityS () {
      findInventoryQuantity({
        tenantName: this.kehuList[this.dqIndex].tenantName
      }).then(res => {
        let obj = {}
        obj.customerName = '暂无信息'
        obj.stockWeight = 0
        // 如果res为【】，制造数据进去
        if (!res.customerList) {
          res.customerList = []
          res.customerList.push(obj)
          this.sum = 0
        }
        this.bingTuList = res.customerList
        this.storageData = []
        this.allWeight = []
        this.sum = 0

        this.bingTuList.forEach((item, index) => {
          this.allWeight.push(item.allWeight)

          let name = item.customerName // customerName客户名称
          let keHuvalue = item.stockWeight // allweight库存量
          let _storage = {}
          _storage['name'] = name
          _storage['value'] = keHuvalue
          this.storageData.push(_storage) // 饼图使用的数据
        })

        this.sum = res.allWeight ? res.allWeight : 0

        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))

        // let myChart2 = this.$echarts.init(document.getElementById('myChart2'))
        // 绘制图表--库存量
        myChart.setOption({
          color: [
            '#38C3B0',
            '#86CA5A',
            '#BFD44F',
            '#FCC248',
            '#FCE448',
            '#F58B41',
            '#F7765B',
            '#525ECD',
            '#547FDB'
          ],
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} '
          },
          title: {
            text: '库存总量\n' + '\n' + this.sum,
            left: 'center',
            top: '40%',
            textStyle: {
              color: '#fff',
              fontWeight: 'normal',
              fontSize: 14
            }
          },
          graphic: [
            {
              type: 'group',
              top: 'middle',
              left: 'center',
              id: 'data'
            }
          ],
          series: [
            {
              name: '库存总量',
              type: 'pie',
              clickable: true, // 是否开启点击
              minAngle: 5, // 最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: true, // 是否启用防止标签重叠策略

              radius: ['40%', '55%'],
              center: ['50%', '50%'],
              labelLine: {
                normal: {
                  length: 1
                }
              },
              data: this.storageData,

              label: {
                align: 'left',
                normal: {
                  formatter (v) {
                    let text = v.name + '-' + Math.round(v.percent) + '%'
                    if (text.length <= 4) {
                      return text
                    } else if (text.length > 4 && text.length <= 10) {
                      return (text = `${text.slice(0, 4)}\n${text.slice(4)}`)
                    } else if (text.length > 10 && text.length <= 18) {
                      return (text = `${text.slice(0, 4)}\n${text.slice(
                        4,
                        10
                      )}\n${text.slice(10)}`)
                    } else if (text.length > 18 && text.length <= 30) {
                      return (text = `${text.slice(0, 4)}\n${text.slice(
                        4,
                        10
                      )}\n${text.slice(10, 18)}\n${text.slice(18)}`)
                    } else if (text.length > 30) {
                      return (text = `${text.slice(0, 4)}\n${text.slice(
                        4,
                        10
                      )}\n${text.slice(10, 18)}\n${text.slice(
                        18,
                        30
                      )}\n${text.slice(30)}`)
                    }
                  },
                  textStyle: {
                    fontSize: 8
                  }
                }
              }
            }
          ]
        })
      })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 2.2 查询仓储租户下全部或指定客户的日入出库量--圆柱
    findOperationQuantityS () {
      findOperationQuantity({
        tenantName: this.kehuList[this.dqIndex].tenantName
      })
        .then(res => {
          this.rDataList = res.inWeight
          this.ChuDataList = res.outWeight
          // 绘制图表--出入库量
          // 日波动
          let chuRuChart = this.$echarts.init(
            document.getElementById('chuRuChart')
          )
          chuRuChart.setOption({
            title: [
              {
                text: res.inWeight, //
                left: '25%',
                top: '50%',
                textAlign: 'center',
                textStyle: {
                  fontWeight: 'normal',
                  color: '#fff',
                  fontSize: 14,
                  textAlign: 'center'
                }
              },
              {
                text: '日入库量(吨)',
                left: '25%',
                top: '85%',
                textAlign: 'center',
                textStyle: {
                  fontWeight: 'normal',
                  color: '#fff',
                  fontSize: 14,
                  textAlign: 'center'
                }
              },
              {
                text: res.outWeight,
                left: '73%',
                top: '50%',
                textAlign: 'center',
                textStyle: {
                  fontWeight: 'normal',
                  color: 'red',
                  fontSize: 14,
                  textAlign: 'center'
                }
              },
              {
                text: '日出库量(吨)',
                left: '73%',
                top: '85%',
                textAlign: 'center',
                textStyle: {
                  fontWeight: 'normal',
                  color: '#fff',
                  fontSize: 14,
                  textAlign: 'center'
                }
              }
            ],
            series: [
              {
                type: 'liquidFill',
                data: [0.5, 0.3333333333333333, 0.16666666666666666],
                radius: '46%',
                color: ['#d46b08', '#fa8c16', '#ffc069'],
                center: ['27%', '55%'],
                outline: {
                  borderDistance: 5,
                  itemStyle: {
                    borderWidth: 6,
                    borderColor: '#d46b08'
                  }
                },
                label: {
                  normal: {
                    formatter: '', // 入库量
                    color: 'red',
                    fontSize: 14
                  }
                },
                backgroundStyle: {
                  color: 'rgba(212, 107, 8, 0.2)'
                }
              },
              {
                type: 'liquidFill',
                data: [0.5, 0.3333333333333333, 0.16666666666666666],
                radius: '46%',
                color: ['#E8EB38', '#E8EB38', '#E8EB38'],
                center: ['75%', '55%'],
                outline: {
                  borderDistance: 5,
                  itemStyle: {
                    borderWidth: 6,
                    borderColor: '#E8EB38'
                  }
                },
                label: {
                  normal: {
                    formatter: '', // 出库量
                    color: 'red',
                    fontSize: 14
                  },
                  color: '#fff'
                },
                backgroundStyle: {
                  color: 'rgba(4,24,74,0.2)'
                }
              }
            ]
          })
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 2.3 查询仓储租户下出入库作业列表
    findOperationQuantityListS () {
      findOperationQuantityList({
        tenantName: this.kehuList[this.dqIndex].tenantName,
        pageNo: 1,
        pageSize: 500
      })
        .then(res => {
          this.workDataList = res.list
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 2.4 查询仓储租户下全部或指定客户的日出入库波动统计
    findInOutQuantityFluctuationS () {
      findInOutQuantityFluctuation({
        tenantName: this.kehuList[this.dqIndex].tenantName
      })
        .then(res => {
          // instock outstock
          res.in.forEach((item, index) => {
            this.instockDateList.push(item.stockDate) // 入库数据-日期
            this.instockWeightList.push(item.weightSum) // 入库数据-数据量
          })
          res.out.forEach((item, index) => {
            this.outstockDateList.push(item.stockDate) // 出库数据-日期
            this.outstockWeightList.push(item.weightSum) // 出库数据-数据
          })
          this.instockDateListSlice = this.instockDateList.slice(-9)
          this.instockWeightListSlice = this.instockWeightList.slice(-9)
          this.outstockDateListSlice = this.outstockDateList.slice(-9)
          this.outstockWeightListSlice = this.outstockWeightList.slice(-9)
          // 日出库量
          let rChart = this.$echarts.init(document.getElementById('rChart'))

          // 绘制图表--日出入库波动
          rChart.setOption({
            tooltip: {
              trigger: 'axis',
              backgroundColor: 'rgba(255,255,255,0.8)', // 通过设置rgba调节背景颜色与透明度
              color: 'black',
              borderWidth: '1',
              borderColor: 'gray',
              textStyle: {
                color: 'black'
              },
              // backgroundColor: 'rgba(255,255,255,1)',
              padding: [5, 10],

              extraCssText: 'box-shadow: 0 0 5px rgba(0,0,0,0.3)'
            },
            legend: {
              right: 20,
              orient: 'vertical',
              color: '#fff',
              data: ['日入库', '日出库'],
              textStyle: {
                color: '#fff'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: this.instockDateListSlice,
                boundaryGap: false,
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#A1C9D9'
                  }
                },
                // 边框设置
                axisLine: {
                  lineStyle: {
                    color: '#0898BA',
                    width: 1 // 粗细
                  }
                },
                // 虚线设置
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#0898BA',
                    type: 'dashed'
                  }
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                data: ['0', '100', '200', '300', '400', '500', '600'],
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#A1C9D9'
                  }
                },
                // 边框设置
                axisLine: {
                  lineStyle: {
                    color: '#0898BA',
                    width: 1 // 粗细
                  }
                },
                // 虚线设置
                splitLine: {
                  show: false,
                  lineStyle: {
                    color: '#0898BA',
                    type: 'dashed'
                  }
                }
              }
            ],
            series: [
              {
                name: '日入库',
                type: 'line',
                smooth: true,
                showSymbol: false,
                symbol: 'circle',
                symbolSize: 6,
                data: this.instockWeightListSlice,
                itemStyle: {
                  normal: {
                    color: '#f7b851'
                  }
                },
                lineStyle: {
                  normal: {
                    width: 3
                  }
                }
              },
              {
                name: '日出库',
                type: 'line',
                smooth: true,
                showSymbol: false,
                symbol: 'circle',
                symbolSize: 6,
                data: this.outstockWeightListSlice,

                itemStyle: {
                  normal: {
                    color: '#58c8da'
                  }
                },
                lineStyle: {
                  normal: {
                    width: 3
                  }
                }
              }
            ]
          })
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 2.5 查询仓储租户下全部或指定客户的日库存量波动统计
    findInventoryQuantityFluctuationS () {
      findInventoryQuantityFluctuation({
        tenantName: this.kehuList[this.dqIndex].tenantName
      })
        .then(res => {
          this.getTWhStatistictDataList = res
          // stockDate: "2020-04-21"
          // weightSum: "0"
          this.getTWhStatistictDataList.forEach((item, index) => {
            item.stockDate = item.stockDate.slice(5) // 截取第二个之后所有的字符 cdef

            this.stockDateList.push(item.stockDate)
            this.weightSumList.push(item.weightSum)
          })
          this.stockDateListSlice = this.stockDateList.slice(-9)
          this.weightSumListSlice = this.weightSumList.slice(-9)

          // 库存量
          let kuCunChart1 = this.$echarts.init(
            document.getElementById('kuCunChart1')
          )
          // 绘制图表--库存量
          kuCunChart1.setOption({
            color: ['#E8EB38'],
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: this.stockDateListSlice,
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#A1C9D9'
                  }
                },
                // 边框设置
                axisLine: {
                  lineStyle: {
                    color: '#0898BA',
                    // color: '#fff', // 颜色
                    width: 1 // 粗细
                  }
                }
              }
            ],
            yAxis: [
              {
                type: 'value',

                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#A1C9D9'
                  }
                },
                // 边框设置
                axisLine: {
                  lineStyle: {
                    color: '#0898BA',
                    // color: '#fff', // 颜色
                    width: 1 // 粗细
                  }
                },
                // 虚线设置
                splitLine: {
                  show: true,
                  lineStyle: {
                    type: 'dashed',
                    color: '#0898BA'
                  }
                }
              }
            ],
            series: [
              {
                name: '库存量',
                type: 'bar',
                barWidth: '20%',
                data: this.weightSumListSlice
              }
            ]
          })
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },

    //= =====================================标题点击事件
    // 点击标题，echarts放大
    echartsClick () {
      this.echartsmark = true
    },
    // 点击出入库量，echarts放大
    chuRuclick () {
      this.chuRuclickmark = true
    },
    // 点击库存量波动，echarts放大
    kuCunClick () {
      this.chuRuclickmark3 = true
    },
    // 点击库存量波动，echarts放大
    rBoDongClick () {
      this.chuRuclickmark4 = true
    },
    // 点击出入库作业，echarts放大
    chuRuWork () {
      this.workMark = true
    },
    //= ===============================点击标题后弹窗打开事件
    openEchartsClick () {
      const t = this
      setTimeout(() => {
        //  执行echarts画图方法
        t.drawLine()
        t.drawLine2()
      }, 0)
    },
    openEchartsClick2 () {
      const t = this
      setTimeout(() => {
        //  执行echarts画图方法
        t.drawLine2()
      }, 0)
    },
    openEchartsClick3 () {
      const t = this
      setTimeout(() => {
        //  执行echarts画图方法
        t.drawLine3()
      }, 0)
    },
    openEchartsClick4 () {
      const t = this
      setTimeout(() => {
        //  执行echarts画图方法
        t.drawLine4()
      }, 0)
    },

    handleClose (done) {
      done()
    },
    //= ===============================点击后放大的echarts
    drawLine () {
      let myChart2 = this.$echarts.init(document.getElementById('myChart2'))
      // 日波动

      // 绘制图表--库存量
      myChart2.setOption({
        color: [
          '#38C3B0',
          '#86CA5A',
          '#BFD44F',
          '#FCC248',
          '#FCE448',
          '#F58B41',
          '#F7765B',
          '#525ECD',
          '#547FDB'
        ],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        title: {
          text: '库存总量\n' + this.sum,
          left: 'center',
          top: '50%',
          textStyle: {
            color: '#fff',
            fontWeight: 'normal',
            fontSize: 18
          }
        },
        graphic: [
          {
            type: 'group',
            top: 'middle',
            left: 'center',
            id: 'data'
          }
        ],
        series: [
          {
            name: '库存总量',
            type: 'pie',
            fontSize: 18,
            clickable: true, // 是否开启点击
            minAngle: 5, // 最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
            avoidLabelOverlap: true, // 是否启用防止标签重叠策略

            radius: ['40%', '80%'],
            center: ['50%', '50%'],
            data: this.storageData,

            label: {
              align: 'left',
              normal: {
                formatter (v) {
                  let text = v.name + '-' + Math.round(v.percent) + '%'
                  if (text.length <= 6) {
                    return text
                  } else if (text.length > 6 && text.length <= 16) {
                    return (text = `${text.slice(0, 6)}\n${text.slice(6)}`)
                  } else if (text.length > 16 && text.length <= 24) {
                    return (text = `${text.slice(0, 6)}\n${text.slice(
                      6,
                      16
                    )}\n${text.slice(16)}`)
                  } else if (text.length > 24 && text.length <= 30) {
                    return (text = `${text.slice(0, 6)}\n${text.slice(
                      6,
                      16
                    )}\n${text.slice(16, 24)}\n${text.slice(24)}`)
                  } else if (text.length > 30) {
                    return (text = `${text.slice(0, 6)}\n${text.slice(
                      6,
                      16
                    )}\n${text.slice(16, 24)}\n${text.slice(
                      24,
                      30
                    )}\n${text.slice(30)}`)
                  }
                },
                textStyle: {
                  fontSize: 8
                }
              }
            }
          }
        ]
      })
    },
    drawLine2 () {
      // 日波动
      let chuRuChart2 = this.$echarts.init(
        document.getElementById('chuRuChart2')
      )

      chuRuChart2.setOption({
        title: [
          {
            text: '日入库量(吨)',
            left: '27%',
            top: '73%',
            textAlign: 'center',
            textStyle: {
              fontWeight: 'normal',
              color: '#fff',
              fontSize: 16,
              textAlign: 'center'
            }
          },
          {
            text: '日出库量(吨)',
            left: '80%',
            top: '73%',
            textAlign: 'center',
            textStyle: {
              fontWeight: 'normal',
              color: '#fff',
              fontSize: 16,
              textAlign: 'center'
            }
          },
          {
            text: '',
            left: '45%',
            top: '7%',
            textAlign: 'center',
            textStyle: {
              fontWeight: 'bold',
              color: 'black',
              fontSize: 16,
              textAlign: 'center'
            }
          }
        ],
        series: [
          {
            type: 'liquidFill',
            data: [0.5, 0.3333333333333333, 0.16666666666666666],
            radius: '50%',
            color: ['#d46b08', '#fa8c16', '#ffc069'],
            center: ['27%', '45%'],
            outline: {
              borderDistance: 5,
              itemStyle: {
                borderWidth: 6,
                borderColor: '#d46b08'
              }
            },
            label: {
              normal: {
                formatter: this.rDataList, // 入库量
                color: 'red',
                fontSize: 16
              }
            },
            backgroundStyle: {
              color: 'rgba(212, 107, 8, 0.2)'
            }
          },
          {
            type: 'liquidFill',
            data: [0.5, 0.3333333333333333, 0.16666666666666666],
            radius: '50%',
            color: ['#E8EB38', '#E8EB38', '#E8EB38'],
            center: ['80%', '45%'],
            outline: {
              borderDistance: 5,
              itemStyle: {
                borderWidth: 6,
                borderColor: '#E8EB38'
              }
            },
            label: {
              normal: {
                formatter: this.ChuDataList, // 出库量
                color: 'red',
                fontSize: 16
              },
              color: 'red'
            },
            backgroundStyle: {
              color: 'rgba(4,24,74,0.2)'
            }
          }
        ]
      })
    },
    drawLine3 () {
      // 库存量
      let kuCunChart12 = this.$echarts.init(
        document.getElementById('kuCunChart12')
      )
      // 绘制图表--库存量
      kuCunChart12.setOption({
        color: ['#E8EB38'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.stockDateList,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 40,
              formatter: '{value}',
              textStyle: {
                color: '#fff'
              }
            },

            // 边框设置
            axisLine: {
              lineStyle: {
                color: '#fff', // 颜色
                width: 1 // 粗细
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#fff'
              }
            },
            // 边框设置
            axisLine: {
              lineStyle: {
                color: '#fff', // 颜色
                width: 1 // 粗细
              }
            },
            // 虚线设置
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            name: '库存量',
            type: 'bar',
            barWidth: '60%',
            data: this.weightSumList
          }
        ]
      })
    },
    drawLine4 () {
      // 日出库量
      let rChart2 = this.$echarts.init(document.getElementById('rChart2'))

      // 绘制图表--日出入库波动
      rChart2.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.8)', // 通过设置rgba调节背景颜色与透明度
          color: 'black',
          borderWidth: '1',
          borderColor: 'gray',
          textStyle: {
            color: 'black'
          },
          // backgroundColor: 'rgba(255,255,255,1)',
          padding: [5, 10],

          extraCssText: 'box-shadow: 0 0 5px rgba(0,0,0,0.3)'
        },
        legend: {
          right: 20,
          orient: 'vertical',
          color: '#fff',
          data: ['日入库', '日出库'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.instockDateList,
            boundaryGap: false,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 40,
              formatter: '{value}',
              textStyle: {
                color: '#fff'
              }
            },
            // 边框设置
            axisLine: {
              lineStyle: {
                color: '#fff', // 颜色
                width: 1 // 粗细
              }
            },
            // 虚线设置
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            data: ['0', '100', '200', '300', '400', '500', '600'],
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#fff'
              }
            },
            // 边框设置
            axisLine: {
              lineStyle: {
                color: '#fff', // 颜色
                width: 1 // 粗细
              }
            },
            // 虚线设置
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            name: '日入库',
            type: 'line',
            smooth: true,
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 6,
            data: this.instockWeightList,
            itemStyle: {
              normal: {
                color: '#f7b851'
              }
            },
            lineStyle: {
              normal: {
                width: 3
              }
            }
          },
          {
            name: '日出库',
            type: 'line',
            smooth: true,
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 6,
            data: this.outstockWeightList,

            itemStyle: {
              normal: {
                color: '#58c8da'
              }
            },
            lineStyle: {
              normal: {
                width: 3
              }
            }
          }
        ]
      })
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style lang='less' scoped>
//出入库作业-弹窗-放大
.chuRuWorkBox {
  #table {
    width: 100%;
    font-size: 12px;
    // height: 3vh;
    overflow: hidden;
    .tables {
      background-color: #0565f7;
      width: 100%;
      color: #fff;
      height: 3vh;
      line-height: 3vh;
      display: flex;
      text-align: center;
      span {
        flex: 1;
      }
      .span_one {
        width: 120px;
        height: 100%;
      }
    }
  }
  .seamless-warp1 {
    height: 70vh;
    overflow: hidden;
    ul {
      margin-top: 10px;
    }
    li {
      display: flex;
      width: 100%;
      height: 3vh;
      line-height: 3vh;
      color: #fff;
      span {
        flex: 1;
        // width: 40%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // padding: 0 2px;
        text-align: center;
      }
      // .oneSpan {
      //   color: red;
      //   flex-shrink: 0;
      // }
      .span {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    #text {
      padding-left: 4vmax;
      font-size: 12px;
      height: 5vh;
      line-height: 5vh;
    }
    .colorYellow {
      // border: 1px solid yellow;
      color: #eed808;
    }
  }
}
//
//表格滚动
#table {
  width: 100%;
  font-size: 12px;
  // height: 3vh;
  overflow: hidden;
  .tables {
    background-color: #0565f7;
    width: 100%;
    color: #fff;
    height: 2vh;
    line-height: 2vh;
    display: flex;
    text-align: center;
    span {
      flex: 1;
    }
    .span_one {
      width: 120px;
      height: 100%;
    }
  }
  .seamless-warp {
    height: 40vh;
    width: 100%;
    overflow: hidden;
    ul {
      margin-top: 10px;
    }
    li {
      display: flex;
      width: 100%;
      height: 3vh;
      line-height: 3vh;
      color: #fff;
      span {
        flex: 1;
        // width: 40%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // padding: 0 2px;
        text-align: center;
      }
      // .oneSpan {
      //   color: red;
      //   flex-shrink: 0;
      // }
      .span {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    #text {
      padding-left: 4vmax;
      font-size: 14px;
      height: 4vh;
      line-height: 4vh;
    }
    .colorYellow {
      // border: 1px solid yellow;
      color: #eed808;
    }
  }
}
.seamless-warp2 {
  height: 40vh;
  width: 100%;
  overflow: hidden;
  ul {
    margin-top: 10px;
  }
  li {
    display: flex;
    width: 100%;
    height: 3vh;
    line-height: 3vh;
    color: #fff;
    span {
      flex: 1;
      // width: 40%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // padding: 0 2px;
      text-align: center;
    }
    // .oneSpan {
    //   color: red;
    //   flex-shrink: 0;
    // }
    .span {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  #text {
    padding-left: 4vmax;
    font-size: 14px;
    height: 4vh;
    line-height: 4vh;
  }
  .colorYellow {
    // border: 1px solid yellow;
    color: #eed808;
  }
}
#myChart {
  height: 200px;
  width: 400px;
}

.storageDaPing {
  height: 100vh;
  padding: 10px;
  overflow: hidden;
  box-sizing: border-box;
  background: url("../../assets/cangchuDaping/bj.jpg") no-repeat 100%;
  //弹窗设置
}
/* 头部 */
.title {
  height: 4vh;
  line-height: 4vh;
  width: 100%;
  display: flex;
  justify-content:center;
  align-items:center;
  // background: url("../../../assets/cangchuDaping/blue.png") no-repeat center;
  .img1 {
    height: 1vh;
  }
  .img2 {
    height: 1vh;
  }
  .h2 {
    color: #00ffff;
    font-size: 22px;
  }
  .kehu {
    position: absolute;
    right: 0;
    font-size: 16px;
    color: #fff;
  }
}

/* 主体 */
.conent {
  height: 93vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1vh;
  .flexBox {
    flex: 1;
    display: flex;
    .top {
      flex: 1;
    }
    .top_left {
      display: flex;
      .topCon {
        flex: 1;
      }
    }
    .center {
      flex: 1;
      width: 40vmax;
    }
  }
  .conent_center {
    margin-top: 1vh;
  }
  .topCon {
    position: relative;
    flex: 1;
    background: rgba(46, 43, 43, 0.13);
    .left_top_one {
      background-size: cover;
    }
    .topCon_body {
      width: 100%;
    }
    .leftTop {
      position: absolute;
      left: 0;
      top: 0;
      width: 10px;
      height: 10px;
      border-top: 2px solid #00ffff;
      border-left: 2px solid #00ffff;
    }
    .leftBottom {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 10px;
      height: 10px;
      border-bottom: 2px solid #00ffff;
      border-left: 2px solid #00ffff;
    }
    .rightBottom {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 10px;
      height: 10px;
      border-bottom: 2px solid #00ffff;
      border-right: 2px solid #00ffff;
    }
    .rightTop {
      position: absolute;
      right: 0;
      top: 0;
      width: 10px;
      height: 10px;
      border-right: 2px solid #00ffff;
      border-top: 2px solid #00ffff;
    }
  }

  .topCon_title {
    width: 100%;
    color: #00ffff;
    height: 3vh;
    line-height: 3vh;
    text-align: center;
    background-color: #082153;
    font-size: 13px;
  }
}
.foot {
  position: relative;
  margin-top: 3vh;
  // border: 1px solid rgba(228, 218, 218, 0.637);
  // background: rgba(46, 43, 43, 0.13);
  .topCon_title {
    width: 100%;
    color: #00ffff;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #082153;
  }
  .topCon_body {
    background: rgba(46, 43, 43, 0.13);

    height: 6vh;
    overflow: hidden;
    color: #fff;
  }
  .seamless-warp3 {
    height: 40vh;
    width: 100%;
    overflow: hidden;
    ul {
      margin-top: 10px;
    }
    li {
      width: 100%;
      height: 7vh;
      // line-height: 3vh;
      color: #fff;
      // margin-top: 3px;
      // margin-bottom: 3px;
    }
    #text {
      padding-left: 4vmax;
      font-size: 12px;
      // margin: 5px 0;
      // height: 4vh;
      // line-height: 4vh;
    }
    .colorYellow {
      // border: 1px solid yellow;
      color: #eed808;
    }
  }
  .leftTop {
    position: absolute;
    left: 0;
    top: 0;
    width: 10px;
    height: 10px;
    border-top: 2px solid #00ffff;
    border-left: 2px solid #00ffff;
  }
  .leftBottom {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 10px;
    height: 10px;
    border-bottom: 2px solid #00ffff;
    border-left: 2px solid #00ffff;
  }
  .rightBottom {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 10px;
    height: 10px;
    border-bottom: 2px solid #00ffff;
    border-right: 2px solid #00ffff;
  }
  .rightTop {
    position: absolute;
    right: 0;
    top: 0;
    width: 10px;
    height: 10px;
    border-right: 2px solid #00ffff;
    border-top: 2px solid #00ffff;
  }
}
.tiaozhuan{
  color: #00ffff;
  position: absolute;
  right: 10px;
  text-decoration: none;
}
</style>
